import { useState, useEffect } from 'react';
import Header from './components/Header/Header';
import YearSelector from './components/YearSelector/YearSelector';
import TabBar from './components/TabBar/TabBar';
import ContentGrid from './components/ContentGrid/ContentGrid';
import DetailPage from './components/DetailPage/DetailPage';
import OnThisDay from './components/OnThisDay/OnThisDay';
import { fetchEgyptianContent } from './services/tmdbService';
import { fetchYouTubeCommercials } from './services/youtubeService';
import { HISTORICAL_DATA } from './data/historicalData';
import { RAMADAN_DATES } from './data/ramadanDates';
import './styles/global.css';

const TABS = ['shows','commercials'];
const API_KEY = process.env.REACT_APP_TMDB_KEY || '';
const YT_KEY = process.env.REACT_APP_YOUTUBE_KEY || '';

export default function App() {
  const [year,setYear] = useState(2026);
  const [tab,setTab] = useState(0);
  const [data,setData] = useState({shows:[],commercials:[]});
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState('');
  const [ytError,setYtError] = useState('');
  const [selectedItem,setSelectedItem] = useState(null);

  useEffect(()=>{
    const load = async () => {
      setLoading(true); setError(''); setYtError('');
      const h = HISTORICAL_DATA[year]||{};
      let r = {shows:h.shows||[],commercials:h.commercials||[]};
      if (API_KEY) {
        try {
          const live = await fetchEgyptianContent(API_KEY,year,RAMADAN_DATES[year]);
          r.shows=[...live.shows,...r.shows];
        } catch { setError('Could not reach TMDB. Check your API key.'); }
      }
      if (YT_KEY) {
        try {
          const ytCommercials = await fetchYouTubeCommercials(YT_KEY,year);
          r.commercials=[...ytCommercials,...r.commercials];
        } catch (e) { setYtError(e.message); }
      }
      setData(r); setLoading(false);
    };
    load();
  },[year]);

  const handleSelect = item => {
    if (window.gtag) window.gtag('event', 'view_item', {
      show_name: item.title,
      show_id: String(item.id),
      content_type: item.mediaType,
      ramadan_year: year,
    });
    setSelectedItem(item);
  };

  if (selectedItem) return <DetailPage item={selectedItem} apiKey={API_KEY} ytKey={YT_KEY} onBack={()=>setSelectedItem(null)}/>;
  return (
    <div className="app">
      <Header/>
      <main className="main">
        <YearSelector year={year} onChange={setYear} dates={RAMADAN_DATES[year]}/>
        <OnThisDay onSelect={handleSelect}/>
        <TabBar active={tab} onChange={setTab}/>
        <ContentGrid items={data[TABS[tab]]} tabIndex={tab} loading={loading} error={error} ytError={tab===1?ytError:''} year={year} hasKey={!!API_KEY} onSelect={handleSelect}/>
      </main>
    </div>
  );
}
